import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./Filters.css";
import { updateFilteredCollections, updateDateRange } from "../../slices/filtersSlice";
import DateTimeRangePicker from "../../common/utils/DateTimeRangePicker";
import FiltersIcon from '../../assets/images/svgs/Filter.svg?react';
import DateIcon from '../../assets/images/svgs/Date.svg?react';
import DataType  from '../../assets/images/svgs/DataType.svg?react';
import { resetFilterOption } from "../../slices/mapSlice";
import MultiSelectDropdown from "../../common/utils/MultiSelectDropdown";
import { searchMultiStacData, searchStacData } from "../../services/stac.service";
import { formatDateOnly } from "../../common/utils/helperFunctions";

const Filters = (props) => {
  const filters = useSelector((state) => state.filters);
  const collectionsData = useSelector((state) => state.collectionDetails.collections);
  const searchView = useSelector((state) => state.map.searchView);
  const multiSearchView = useSelector(state => state.map.multiSearchView);
  const multicoordinates = useSelector(state => state.map.multicoordinates);

  const dispatch = useDispatch();

  const [selectedCollections, setSelectedCollections] = useState(
    filters.filteredCollections?.length > 0
      ? filters.filteredCollections
      : (filters.filteredCollection?.collectionID ? [filters.filteredCollection] : [])
  );
  // const [dataValue, setDataValue] = useState(filters.filterDataType);
  const [startDate, setStartDate] = useState(filters.startDate);
  const [endDate, setEndDate] = useState(filters.endDate);

  const collectionsWithStats = selectedCollections.filter(
    (item) => item.firstItemDatetime && item.lastItemDatetime
  );
  const earliestAvailableDate = collectionsWithStats.length > 0
    ? collectionsWithStats.reduce((min, item) => item.firstItemDatetime < min ? item.firstItemDatetime : min, collectionsWithStats[0].firstItemDatetime)
    : null;
  const latestAvailableDate = collectionsWithStats.length > 0
    ? collectionsWithStats.reduce((max, item) => item.lastItemDatetime > max ? item.lastItemDatetime : max, collectionsWithStats[0].lastItemDatetime)
    : null;

  useEffect(() => {
    if (earliestAvailableDate && latestAvailableDate) {
      setStartDate(earliestAvailableDate);
      setEndDate(latestAvailableDate);
    }
  }, [earliestAvailableDate, latestAvailableDate]);

  // const geodataProviderData = [
  //   { eventKey: "landsat-c2l2-sr", label: "LANDSAT" },
  //   { eventKey: "SENTINEL-2", label: "SENTINEL" },
  //   { eventKey: "MAXAR", label: "MAXAR" },
  //   { eventKey: "ANTARIS", label: "ANTARIS" },
  //   { eventKey: "BHOONIDHI", label: "BHOONIDHI" },
  // ];

  // const dropdownOptions = dataValue === 'GeodataProvider'
  //   ? geodataProviderData
  //   : collectionsData?.filter(item => item.name !== 'landsat-c2l2-sr' && item.name !== 'SENTINEL-2')
  //     .map(item => ({
  //       eventKey: item.name,
  //       label: item.name
  //     })) || [];

  const ApplyFilters = () => {
    dispatch(
      updateDateRange({
        startDate: startDate,
        endDate: endDate,
      })
    );
    dispatch(updateFilteredCollections(selectedCollections));
    // dispatch(updateFilterDataType(dataValue));
    dispatch(resetFilterOption());
    if (searchView) {
      dispatch(searchStacData());
    } else if(multiSearchView){      
          if (multicoordinates && Array.isArray(multicoordinates.features)) {
            multicoordinates.features.forEach((feature,index) => {
              const geometry = feature.geometry;
              const name = `${feature.geometry.type}-${index + 1}`;
              if (geometry && geometry.type && geometry.coordinates) {
                dispatch(searchMultiStacData(geometry,name));
              }
            });
          }
        }
  };

  // const getLabelForEventKey = (key) => {
  //   const selectedItem = collectionsData.find((item) => item.name === key);
  //   return selectedItem ? selectedItem.name : "Select a value";
  // };

  const onCollectionsChange = (selectedItems) => {
    setSelectedCollections(selectedItems);
  };

  // const handleChange = (event, type) => {
  //   setDataValue(type);

  //   let updatedOptions = [];
  //   if (type === 'GeodataProvider') {
  //     updatedOptions = geodataProviderData;
  //   } else if (type === 'Collection') {
  //     updatedOptions = collectionsData
  //       ?.filter(item => item.name !== 'landsat-c2l2-sr' && item.name !== 'SENTINEL-2')
  //       .map(item => ({
  //         eventKey: item.name,
  //         label: item.name,
  //       })) || [];
  //   }

  //   if (updatedOptions.length > 0) {
  //     setCollectionValue(updatedOptions[0].eventKey);
  //   } else {
  //     setCollectionValue('');
  //   }
  // };

  return (
    <div className="popupBox filtersBox">
      <div className="popupBoxDiv" style={{ padding: "4px" }}>
        <FiltersIcon fill="#CCF54E" />
        <div className="popupBoxText popupBoxHeaderText">Filters</div>
      </div>

      <div className="noPadding">
        <div className="dataTypeFilters">
          <div className="fc-daygrid-dot-event flex-row">
            <DataType />
            <div className="collection-dropdown-title">Collection (Data Type) </div>
          </div>
          {/* <div className="dataTypeFiltersOptions">
            <div className="modalInputBox" key={'GeodataProvider'}>
              <button
                name="GeodataProvider"
                onClick={(e) => handleChange(e, 'GeodataProvider')}
                className={dataValue === 'GeodataProvider' ? "modalInputCircularButton active" : "modalInputCircularButton"}
              />
              <div className="modalInputBoxText">Geodata Provider</div>
            </div>
            <div className="modalInputBox" key={'Collection'}>
              <button
                name="Collection"
                onClick={(e) => handleChange(e, 'Collection')}
                className={dataValue === 'Collection' ? "modalInputCircularButton active" : "modalInputCircularButton"}
              />
              <div className="modalInputBoxText">Collection</div>
            </div>
          </div> */}
        </div>

        <MultiSelectDropdown
          options={collectionsData}
          onSelectionChange={onCollectionsChange}
          selectedValues={selectedCollections}
          keyName="collectionID"
          valueName="name"
          dropdownName="collections"
          placeholder="Select collection(s)"
          itemLabel="collection"
          toggleClass="dropdown-toggle-width"
          menuClass="dropdown-menu-width"
        />

        <div>
          <div className="fc-daygrid-dot-event flex-row">
            <DateIcon />
            <div className="collection-dropdown-title">Date Range</div>
          </div>
          {earliestAvailableDate && (
            <div className="collectionStatsHint">
              <div>Data available:</div>
              <div>{formatDateOnly(earliestAvailableDate)} &ndash; {formatDateOnly(latestAvailableDate)}</div>
            </div>
          )}
          <DateTimeRangePicker
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            minDate={earliestAvailableDate}
            maxDate={latestAvailableDate}
          />
        </div>
      </div>
      <div className="popupBoxButtons">
        <button
          className="modalFooterCloseBtn applyFiltersBtn"
          onClick={() => dispatch(resetFilterOption())}
        >
          Cancel
        </button>
        <button
          className="modalFooterApplyBtn applyFiltersBtn"
          onClick={ApplyFilters}
        >
          Apply
        </button>
      </div>
    </div >
  )
};

export default Filters;
